<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Campaigns</div>
      <router-link to="/game/ArchiveCampaigns" class="tabulka__top__button"
        >View campaign archive
      </router-link>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Round</span>
            <SortButton
              row="turn"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Product</span>
            <SortButton
              row="product.name"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td class="right">
            <SortButton
              row="totalPrice"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Spent</span>
          </td>
        </thead>
        <tr v-for="campaign in sortedData" :key="campaign.id">
          <td class="important">
            <span>{{ campaign.turn }}.</span>
          </td>
          <td>
            <div class="table__product-name">{{ campaign.product.name }}</div>
            <div class="table__product-view" @click="goToCampaign(campaign)">
              <div class="table__product-view--img"></div>
            </div>
          </td>
          <td class="right">{{ campaign.totalPrice }} €</td>
        </tr>
        <tr v-if="!sourceData.length">
          <td>{{ $t(`texts.data.no-campaigns-purchased`) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani

export default {
  name: "Campaigns",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
  },
  props: {
    TableWidth: String,
  },
  data() {
    return {
      currentSortRow: "turn",
      currentSortDirection: -1,
    };
  },
  computed: {
    ...mapGetters({
      sourceData: "groupedCampaignsOverview",
    }),
  },
  methods: {
    goToCampaign(campaign) {
      this.$router.push({
        name: campaign.items[0].archived
          ? "Game.ArchiveCampaigns"
          : "Game.SetCampaigns",
      });
    },
  },
};
</script>
